__turbopack_context__.v({
  "loading": "style-module-scss-module__kpSpEa__loading",
  "mobile-nav": "style-module-scss-module__kpSpEa__mobile-nav",
  "page": "style-module-scss-module__kpSpEa__page",
});
